// iter-80: country dial codes — covers the top ~70 markets BecAim is most
// likely to see organic signups from. Sorted with India first (default), then
// the rest alphabetically by country name. The `flag` field is an emoji so
// rendering is dependency-free across mobile/desktop.
const COUNTRY_CODES = [
  { code: '+91', flag: '🇮🇳', country: 'India', minDigits: 10, maxDigits: 10 },
  { code: '+1',  flag: '🇺🇸', country: 'United States', minDigits: 10, maxDigits: 10 },
  { code: '+1',  flag: '🇨🇦', country: 'Canada', minDigits: 10, maxDigits: 10 },
  { code: '+44', flag: '🇬🇧', country: 'United Kingdom', minDigits: 10, maxDigits: 10 },
  { code: '+61', flag: '🇦🇺', country: 'Australia', minDigits: 9, maxDigits: 9 },
  { code: '+971',flag: '🇦🇪', country: 'UAE', minDigits: 9, maxDigits: 9 },
  { code: '+966',flag: '🇸🇦', country: 'Saudi Arabia', minDigits: 9, maxDigits: 9 },
  { code: '+65', flag: '🇸🇬', country: 'Singapore', minDigits: 8, maxDigits: 8 },
  { code: '+60', flag: '🇲🇾', country: 'Malaysia', minDigits: 9, maxDigits: 10 },
  { code: '+62', flag: '🇮🇩', country: 'Indonesia', minDigits: 9, maxDigits: 12 },
  { code: '+63', flag: '🇵🇭', country: 'Philippines', minDigits: 10, maxDigits: 10 },
  { code: '+66', flag: '🇹🇭', country: 'Thailand', minDigits: 9, maxDigits: 9 },
  { code: '+84', flag: '🇻🇳', country: 'Vietnam', minDigits: 9, maxDigits: 10 },
  { code: '+880',flag: '🇧🇩', country: 'Bangladesh', minDigits: 10, maxDigits: 11 },
  { code: '+92', flag: '🇵🇰', country: 'Pakistan', minDigits: 10, maxDigits: 10 },
  { code: '+94', flag: '🇱🇰', country: 'Sri Lanka', minDigits: 9, maxDigits: 9 },
  { code: '+977',flag: '🇳🇵', country: 'Nepal', minDigits: 10, maxDigits: 10 },
  { code: '+86', flag: '🇨🇳', country: 'China', minDigits: 11, maxDigits: 11 },
  { code: '+81', flag: '🇯🇵', country: 'Japan', minDigits: 10, maxDigits: 10 },
  { code: '+82', flag: '🇰🇷', country: 'South Korea', minDigits: 9, maxDigits: 10 },
  { code: '+852',flag: '🇭🇰', country: 'Hong Kong', minDigits: 8, maxDigits: 8 },
  { code: '+49', flag: '🇩🇪', country: 'Germany', minDigits: 10, maxDigits: 12 },
  { code: '+33', flag: '🇫🇷', country: 'France', minDigits: 9, maxDigits: 9 },
  { code: '+34', flag: '🇪🇸', country: 'Spain', minDigits: 9, maxDigits: 9 },
  { code: '+39', flag: '🇮🇹', country: 'Italy', minDigits: 9, maxDigits: 11 },
  { code: '+31', flag: '🇳🇱', country: 'Netherlands', minDigits: 9, maxDigits: 9 },
  { code: '+46', flag: '🇸🇪', country: 'Sweden', minDigits: 9, maxDigits: 9 },
  { code: '+47', flag: '🇳🇴', country: 'Norway', minDigits: 8, maxDigits: 8 },
  { code: '+45', flag: '🇩🇰', country: 'Denmark', minDigits: 8, maxDigits: 8 },
  { code: '+41', flag: '🇨🇭', country: 'Switzerland', minDigits: 9, maxDigits: 9 },
  { code: '+43', flag: '🇦🇹', country: 'Austria', minDigits: 9, maxDigits: 11 },
  { code: '+32', flag: '🇧🇪', country: 'Belgium', minDigits: 9, maxDigits: 9 },
  { code: '+351',flag: '🇵🇹', country: 'Portugal', minDigits: 9, maxDigits: 9 },
  { code: '+353',flag: '🇮🇪', country: 'Ireland', minDigits: 9, maxDigits: 9 },
  { code: '+30', flag: '🇬🇷', country: 'Greece', minDigits: 10, maxDigits: 10 },
  { code: '+90', flag: '🇹🇷', country: 'Turkey', minDigits: 10, maxDigits: 10 },
  { code: '+7',  flag: '🇷🇺', country: 'Russia', minDigits: 10, maxDigits: 10 },
  { code: '+972',flag: '🇮🇱', country: 'Israel', minDigits: 9, maxDigits: 9 },
  { code: '+974',flag: '🇶🇦', country: 'Qatar', minDigits: 8, maxDigits: 8 },
  { code: '+968',flag: '🇴🇲', country: 'Oman', minDigits: 8, maxDigits: 8 },
  { code: '+965',flag: '🇰🇼', country: 'Kuwait', minDigits: 8, maxDigits: 8 },
  { code: '+973',flag: '🇧🇭', country: 'Bahrain', minDigits: 8, maxDigits: 8 },
  { code: '+20', flag: '🇪🇬', country: 'Egypt', minDigits: 10, maxDigits: 10 },
  { code: '+27', flag: '🇿🇦', country: 'South Africa', minDigits: 9, maxDigits: 9 },
  { code: '+234',flag: '🇳🇬', country: 'Nigeria', minDigits: 10, maxDigits: 10 },
  { code: '+254',flag: '🇰🇪', country: 'Kenya', minDigits: 9, maxDigits: 10 },
  { code: '+255',flag: '🇹🇿', country: 'Tanzania', minDigits: 9, maxDigits: 9 },
  { code: '+256',flag: '🇺🇬', country: 'Uganda', minDigits: 9, maxDigits: 9 },
  { code: '+233',flag: '🇬🇭', country: 'Ghana', minDigits: 9, maxDigits: 9 },
  { code: '+212',flag: '🇲🇦', country: 'Morocco', minDigits: 9, maxDigits: 9 },
  { code: '+216',flag: '🇹🇳', country: 'Tunisia', minDigits: 8, maxDigits: 8 },
  { code: '+213',flag: '🇩🇿', country: 'Algeria', minDigits: 9, maxDigits: 9 },
  { code: '+52', flag: '🇲🇽', country: 'Mexico', minDigits: 10, maxDigits: 10 },
  { code: '+55', flag: '🇧🇷', country: 'Brazil', minDigits: 10, maxDigits: 11 },
  { code: '+54', flag: '🇦🇷', country: 'Argentina', minDigits: 10, maxDigits: 11 },
  { code: '+56', flag: '🇨🇱', country: 'Chile', minDigits: 9, maxDigits: 9 },
  { code: '+57', flag: '🇨🇴', country: 'Colombia', minDigits: 10, maxDigits: 10 },
  { code: '+51', flag: '🇵🇪', country: 'Peru', minDigits: 9, maxDigits: 9 },
  { code: '+58', flag: '🇻🇪', country: 'Venezuela', minDigits: 10, maxDigits: 10 },
  { code: '+593',flag: '🇪🇨', country: 'Ecuador', minDigits: 9, maxDigits: 9 },
  { code: '+64', flag: '🇳🇿', country: 'New Zealand', minDigits: 8, maxDigits: 10 },
  { code: '+48', flag: '🇵🇱', country: 'Poland', minDigits: 9, maxDigits: 9 },
  { code: '+420',flag: '🇨🇿', country: 'Czechia', minDigits: 9, maxDigits: 9 },
  { code: '+36', flag: '🇭🇺', country: 'Hungary', minDigits: 8, maxDigits: 9 },
  { code: '+40', flag: '🇷🇴', country: 'Romania', minDigits: 9, maxDigits: 9 },
];

export const DEFAULT_COUNTRY = COUNTRY_CODES[0];
export default COUNTRY_CODES;
